// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"98c3787f","186":"040914a7","241":"2ef0fcfe","253":"dd835279","282":"1035bf1d","401":"80954b69","448":"17d6e9b1","581":"e5721a64","649":"9b5fe8e0","739":"3ca77101","970":"cff42ec2","978":"94f274fc"}[chunkId] + ".chunk.js";
};